import { traverse } from './traverse';

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function reduce(adf, callback, initial) {
  var result = initial;
  traverse(adf, {
    any: function any(node) {
      result = callback(result, node);
    }
  });
  return result;
}